/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2021-04-23 15:10:22
 * @LastEditors: kai.zhou
 * @LastEditTime: 2021-04-25 20:18:11
 */
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

const renderRoutes = (routes: any, outerProps = {}) => {
  return routes ? (
    <Switch>
      {routes
        .filter((route: any) => route.redirect)
        .map((route: any, i: number) => (
          <Redirect
            key={i}
            exact={true}
            from={route.path}
            to={route.redirect}
          />
        ))}
      {routes.map((route: any, i: number) => {
        return route.component ? (
          <Route
            key={i}
            path={route.path}
            exact={route.exact ? true : false}
            render={(props) => (
              <route.component
                {...props}
                {...outerProps}
                routes={route.routes}
                currentMenuItem={route}
              />
            )}
          />
        ) : (
          <Redirect key={100000} exact={true} to={"/error"} />
        );
      })}
    </Switch>
  ) : null;
};

export { renderRoutes };
